import React from 'react';

export function CmsStyles({ styles }: { styles?: string }) {
  if (!styles) return null;
  return <style dangerouslySetInnerHTML={{ __html: styles }} />;
}
